var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreferredVendor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.253,
    height: 43.253,
    viewBox: "0 0 43.253 43.253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "has-stroke",
    "data-name": "Layer 2",
    transform: "translate(.5 .5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aBr4oV.tif"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    d: "M20.3 0c.7.137 1.4.237 2.09.413a12.092 12.092 0 0 1 8.985 12.228 11.945 11.945 0 0 1-5.737 9.851c-.1.066-.2.135-.335.229.484.191.928.356 1.366.538a19.154 19.154 0 0 1 6.307 4.271 1.268 1.268 0 0 1 .408 1.268 1.243 1.243 0 0 1-2.1.547C30.639 28.751 30 28.134 29.3 27.6a16.014 16.014 0 0 0-8.864-3.317A16.738 16.738 0 0 0 2.723 38.225a25.666 25.666 0 0 0-.241 2.666 1.276 1.276 0 0 1-1.244 1.362A1.248 1.248 0 0 1 0 40.86a19.239 19.239 0 0 1 12.826-17.99l.379-.135c-.143-.1-.248-.165-.35-.235C8.84 19.837 6.8 16.095 7.16 11.29 7.542 6.225 10.27 2.708 14.974.8a19.02 19.02 0 0 1 2.949-.72l.315-.08zm-1.08 21.777a9.529 9.529 0 0 0 9.7-9.637 9.676 9.676 0 1 0-19.351.027 9.547 9.547 0 0 0 9.651 9.61z",
    className: "cls-1",
    "data-name": "Path 142"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    d: "M293.885 301.513a7.5 7.5 0 0 1-.727 1.019q-5.863 5.894-11.75 11.764c-.195.195-.378.4-.574.593a1.233 1.233 0 0 1-1.83 0q-2.166-2.179-4.325-4.366a1.234 1.234 0 0 1 .508-2.124 1.252 1.252 0 0 1 1.268.4c1.036 1.046 2.08 2.084 3.118 3.128a3.769 3.769 0 0 1 .3.393c.186-.177.3-.285.418-.4 3.783-3.782 7.577-7.555 11.341-11.356a1.265 1.265 0 0 1 2.212.549c0 .025.031.045.046.068z",
    className: "cls-1",
    "data-name": "Path 143",
    transform: "translate(-251.633 -275.353)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferredVendor);
export default __webpack_public_path__ + "static/media/preferred-vendor.a6375055e1eb587712874b532bbd2a15.svg";
export { ForwardRef as ReactComponent };